import PropTypes from "prop-types";

import StraightLineTool, {
  straightLinePropTypes,
  straightLineBaseDefaults,
} from "./StraightLineTool";
import EachTrendLine from "./wrapper/EachTrendLine";

// Config sobre StraightLineTool (auditoria 2026-07-17, item 1b)
class TrendLine extends StraightLineTool {}

TrendLine.collectionKey = "trends";
TrendLine.EachComponent = EachTrendLine;
TrendLine.evoId = "interactive-trend-line";

TrendLine.propTypes = {
  ...straightLinePropTypes,
  type: PropTypes.oneOf([
    "XLINE", // extends from -Infinity to +Infinity
    "RAY", // extends to +/-Infinity in one direction
    "LINE", // extends between the set bounds
  ]),
  trends: PropTypes.array.isRequired,
};

TrendLine.defaultProps = {
  ...straightLineBaseDefaults,
  type: "LINE",
  trends: [],
};

export default TrendLine;
